module.exports = __webpack_public_path__ + "static/kotlin-3caeca0bf120c4bf68d6cba57a1d967a.png";